export default __webpack_public_path__ + "static/image-34-21427811ceae1be484ab6ef47aeef388.jpg";